exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-57df9a10]::-webkit-inner-spin-button,input[data-v-57df9a10]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-57df9a10]{-moz-appearance:textfield}", ""]);

// exports
